import Preloader from 'ninelines-preloader';
import '../vendor/masonry.pkgd';

Preloader.init()
  .then(() => {
    document.querySelector('.site').classList.remove('is-hidden');
    document.querySelector('.preloader').classList.add('is-active');
    setTimeout(() => {
      document.querySelector('.preloader').classList.add('is-hidden');
    }, 700);
    setTimeout(() => {
      $(document).trigger('preloader-finish');
    }, 50);
  });

  // document.querySelector('.site').classList.remove('is-hidden');
  // document.querySelector('.preloader').classList.add('is-active');
  // setTimeout(() => {
  //   document.querySelector('.preloader').classList.add('is-hidden');
  // }, 700);

  // setTimeout(() => {
  //   $(document).trigger('preloader-finish');
  // }, 50);